module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"select-field-dialog\" title=\"Synchronize\" style=\"display: none;\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <table id=\"propMainTableModal\"></table>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <textarea name=\"logText\" id=\"\" cols=\"30\" rows=\"2\" class=\"disabled\" readonly></textarea>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-2 col-md-offset-5\">\r\n            <input type=\"button\" class=\"btn btn-default\" value=\"Confirm All\" name=\"confirmAll\" />\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n            <input type=\"button\" class=\"btn btn-default\" value=\"Unconfirm All\" name=\"unconfirmAll\" />\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n            <select name=\"filter\" id=\"accountFilter\">\r\n                <option value=\"all\">All</option>\r\n                <option value=\"user\">User</option>\r\n                <option value=\"userGroup\">User Group</option>\r\n                <option value=\"position\">Position</option>\r\n                <option value=\"new\">New</option>\r\n                <option value=\"change\">Change</option>\r\n                <option value=\"remove\">Remove</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}